import {PlusIcon} from '@primer/octicons-react'
import {Button, type ButtonProps, IconButton, type IconButtonProps} from '@primer/react'
import {Tooltip} from '@primer/react/deprecated'

import {LABELS} from './constants/labels'

export type CreateIssueButtonLoadingProps = {
  label: string
  size?: 'small' | 'medium'
  iconOnly?: boolean
  leadingVisual?: ButtonProps['leadingVisual']
}

export const CreateIssueButtonLoading = ({
  label,
  size = 'medium',
  iconOnly = false,
  leadingVisual,
}: CreateIssueButtonLoadingProps): React.ReactElement | null => {
  if (iconOnly) {
    const icon = (leadingVisual ?? PlusIcon) as IconButtonProps['icon']
    return (
      <Tooltip aria-label={LABELS.loadingTooltip}>
        <IconButton size={size} icon={icon} aria-label={label} disabled />
      </Tooltip>
    )
  }

  return (
    <Tooltip aria-label={LABELS.loadingTooltip}>
      <Button size={size} disabled leadingVisual={leadingVisual}>
        {label}
      </Button>
    </Tooltip>
  )
}
